import { PosOrderCreateInput } from '@/features/graphql/generated/graphql'
import { posOrderMutation } from '@/features/pos/components/OrderFinalization/mutations'
import { logger } from '@/features/pos/logger'
import { useHandleErrorWithToast } from '@/hooks/useHandleErrorWithToast'
import { useMutation } from '@apollo/client'

export const useCreatePosOrder = (): ((
    cartKey: string,
    orderData: PosOrderCreateInput
) => Promise<string | undefined>) => {
    const handleError = useHandleErrorWithToast(logger)

    const [posOrder] = useMutation(posOrderMutation, { onError: handleError })

    return async (cartKey: string, orderData: PosOrderCreateInput) => {
        const { data } = await posOrder({ variables: { cartKey, orderData } })

        return data?.posOrder?.uuid
    }
}
